import billing from './billing';
import useDnsModal from './useDnsModal';
import usePaymentModal from './usePaymentModal';
import useBlockedWindowModal from './useBlockedWindowModal';
import routes from './routes';
import sites from './sites';
import domains from './domains';
import products from './products';
import asaas from './asaas';
import alerts from './alerts';
import preChat from './preChat';
import ticket from './ticket';
import backup from './backup';
import security from './security';
import myData from './myData';
import emailVerify from './emailVerify';
import template from './template';
import phoneValidation from './phoneValidation';
import videoClasses from './videoClasses';
import linkNaBio from './linkNaBio';
import gatorProtect from './gatorProtect';
import cloudflare from './cloudflare';
import menu from './menu';
import home from './home';
import changeDomain from './chandeDomain';
import onboarding from './onboarding';
import domainRegister from './domainRegister';
import buyDomain from './buyDomain';
import fastCheckout from './fastCheckout';
import titanWithoutDomain from './titanWithoutDomain';
import aichat from './aichat';
import marketing from './marketing';
import productDetails from './productDetails';
import { config } from '@/config';

const contents = {
  billing,
  routes,
  sites,
  domains,
  products,
  asaas,
  alerts,
  preChat,
  ticket,
  backup,
  security,
  myData,
  emailVerify,
  template,
  phoneValidation,
  videoClasses,
  linkNaBio,
  gatorProtect,
  useDnsModal,
  usePaymentModal,
  useBlockedWindowModal,
  cloudflare,
  menu,
  home,
  changeDomain,
  onboarding,
  domainRegister,
  buyDomain,
  fastCheckout,
  titanWithoutDomain,
  aichat,
  marketing,
  productDetails,
};

const getCountry = () => config.COUNTRY.toUpperCase();

const defaultCountry = getCountry();

const get = (type, brand = defaultCountry) => contents[type][brand];

const extraLatamBrands = [
  'AR',
  'PE',
  'EC',
  'DO',
  'UY',
  'CR',
  'BO',
  'PY',
  'SV',
  'PA',
];

const getAll = (brand = defaultCountry) => {
  const newContents = { ...contents };

  Object.keys(contents).forEach((content) => {
    const contentKeys = Object.keys(newContents[content]);
    extraLatamBrands.forEach((extraBrand) => {
      if (!extraBrand.includes(contentKeys)) {
        const defaultContent = newContents[content].ES || newContents[content].MX;

        newContents[content][extraBrand] = { ...defaultContent };
      }
    });
  });

  const reduced = Object.keys(newContents).reduce((obj, key) => ({
    ...obj,
    [key]: contents[key][brand],
  }), {});

  return reduced;
};

const locale = {
  get,
  getAll,
};

export default locale;
